export default __webpack_public_path__ + "static/media/LOGO.bb1c78bd.svg";